import React,{ useEffect, useState} from "react";
import { connect } from "react-redux";

import { Autocomplete } from "@material-ui/lab";
import {
    TextField,
    Button,
    Accordion as MuiExpansionPanel,
    AccordionDetails as MuiExpansionPanelDetails,
} from "@material-ui/core";
import { makeStyles, withStyles } from "@material-ui/core/styles";

//store
import * as actions from "../../../../store/actions/actionIndex";

const Accordion = withStyles({
    root: {
        // border: '1px solid rgba(0, 0, 0, .125)',
        boxShadow: "none",
        "&:not(:last-child)": {
            borderBottom: 0,
        },
        "&:before": {
            display: "none",
        },
        "&$expanded": {
            margin: "auto",
        },
    },
    expanded: {},
})(MuiExpansionPanel);

const AccordionDetails = withStyles((theme) => ({
    root: {
        padding: "8px 0px 24px",
        display: "inline-flex",
    },
}))(MuiExpansionPanelDetails);

const useStyles = makeStyles((theme) => ({
    label: {
        display: "block",
    },
    input: {
        width: 246,
        height: 25,
    },
    listbox: {
        width: 246,
        margin: 0,
        padding: 0,
        zIndex: 1,
        position: "absolute",
        listStyle: "none",
        backgroundColor: theme.palette.background.paper,
        overflow: "auto",
        maxHeight: 200,
        border: "1px solid rgba(0,0,0,.25)",
        '& li[data-focus="true"]': {
            backgroundColor: "#4a8df6",
            color: "white",
            cursor: "pointer",
        },
        "& li:active": {
            backgroundColor: "#2977f5",
            color: "white",
        },
    },
    submitbutton: {
        margin: 0,
        padding: theme.spacing(1),
    },
    header: {
        border: 0,
        fontSize: "14px",
        fontWeight: "600",
        color: "#343A58",
        paddingInlineStart: "0px !important",
    },
    option: {
        fontSize: 15,
        "& > span": {
            marginInlineEnd: 10,
            fontSize: 18,
        },
    },
    inputField: {
        width: 300,
        margin: 0,
        padding: 0,
    },
}));

function TransferForm(props) {
    const classes = useStyles();
    const [value1, setValue1] = useState("");
    const [value2, setValue2] = useState("");
    const [value3, setValue3] = useState("");
    const [open, setOpen] = useState(false);
    const [openAgent, setOpenAgent] = useState(false);
    const [skillsArr, setSkillsArr] = useState([]);
    const { transferType, transferVal } = props;
    let agentsArr = [];
   
    
    const handleTransfer = () => {
        if (transferType === "Agent" || transferVal === "Agent") {
            props.onTransferAgent(props.agentId, value3);
        } else if (transferType === "Campaign") {
            props.onTransferCampaign(
                props.agentId,
                value1,
                value2 === "" ? 0 : 1,
                value2
            );
        } else if (transferType === "Extension") {
            props.onTransferExtension(props.agentId, value1);
        }
    };
 
    const handleSkill = (e, v) => {
        //console.log("Inside",e,v);
        setValue2(v.skill_id ? v.skill_id : "");
        if (v && transferVal === "Agent") {
            props.onGetTransferableAgents(props.agentId, value1, v.skill_id);
            setOpenAgent(true);
        }
    };
    const handleAgent = (v) => {
        //console.log("Inside",e,v);
        setValue3(v ? v : "");
    };
    const handleChange = (value) => {
        setValue1(value);
        if (value) {
            props.onGetTransferableSkill(props.agentId, value);
            setOpen(true);
        }
    };

        
  useEffect(() => {
    if (skillsArr.length !== 0) {
        handleSkill(null, '0');
    }
}, [skillsArr]);
    
    useEffect(() => {
        if (
            transferType === "Campaign" &&
            open &&
            !props.skillError &&
            !props.skillLoading
        ) {
            try {
                const updatedSkillsArr = Array.from(props.transferableSkills);
                updatedSkillsArr.push({ skill_id: '0', skill_name: 'No Skilled Agent' });
                setSkillsArr(updatedSkillsArr); // Update skillsArr state
            } catch (e) {}
        }
    }, [transferType, open, props.skillError, props.skillLoading, props.transferableSkills]);

    let skills = "";
       
        if (skillsArr.length) {
			
            skills = (
                <Autocomplete
                    id="transferField2"
                    style={{ width: 300, marginTop: "20px" }}
                    options={skillsArr}
                    defaultValue={skillsArr.find(skill => skill.skill_id === '0')}
                    onChange={(event, value) => handleSkill(event, value)}
                    classes={{
                        option: classes.option,
                    }}
                    autoHighlight
                    getOptionLabel={(option) => option.skill_name}
                    renderOption={(option) => (
                        <React.Fragment>
                            <span>{option.skill_name}</span>
                        </React.Fragment>
                    )}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label="Choose a Skill"
                            variant="outlined"
                            className={classes.inputField}
                            inputProps={{
                                ...params.inputProps,
                                autoComplete: "new-password", // disable autocomplete and autofill
                            }}
                        />
                    )}
                />
            );
        }

    let agents = "";
    if (transferVal === "Agent" && openAgent && !props.error &&
    !props.loading) {
        try {
            agentsArr = Array.from(props.transferableAgents);
           
        } catch (e) {}
        if (agentsArr.length) {
            agents = (
                <Autocomplete
                    id="transferField1"
                    style={{ width: 300, marginTop: "20px" }}
                    options={agentsArr}
                    onChange={(event, value) =>
                        handleAgent(value.agent_id ? value.agent_id : "")
                    }
                    classes={{
                        option: classes.option,
                    }}
                    autoHighlight
                    getOptionLabel={(option) => option.agent_id}
                    renderOption={(option) => (
                        <React.Fragment>
                            <span>{option.agent_name}</span>
                            {option.agent_id}
                        </React.Fragment>
                    )}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label="Choose an Agent"
                            variant="outlined"
                            className={classes.inputField}
                            inputProps={{
                                ...params.inputProps,
                                autoComplete: "new-password", // disable autocomplete and autofill
                            }}
                        />
                    )}
                />
            );
        }
    }
    let options = "";
    if (transferType === "Campaign") {
        options = (
            <Autocomplete
                id="transferField1"
                style={{ width: 300 }}
                options={Array.from(props.transferableCampaign)}
                onChange={(event, value) =>
                    handleChange(value.campaign_name ? value.campaign_name : "")
                }
                classes={{
                    option: classes.option,
                }}
                autoHighlight
                getOptionLabel={(option) => option.campaign_name}
                renderOption={(option) => (
                    <React.Fragment>
                        <span>{option.campaign_name}</span>
                    </React.Fragment>
                )}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={"Choose a Campaign"}
                        variant="outlined"
                        className={classes.inputField}
                        inputProps={{
                            ...params.inputProps,
                            autoComplete: "new-password", // disable autocomplete and autofill
                        }}
                    />
                )}
            />
        );
    } else if (transferType === "Extension") {
        options = (
            <Autocomplete
                id="transferField1"
                style={{ width: 300 }}
                options={Array.from(props.transferableExtension)}
                onChange={(event, value) =>
                    setValue1(value.extension_id ? value.extension_id : "")
                }
                classes={{
                    option: classes.option,
                }}
                autoHighlight
                getOptionLabel={(option) => option.extension_id}
                renderOption={(option) => (
                    <React.Fragment>
                        <span>{option.extension_name}</span>
                        {option.extension_id}
                    </React.Fragment>
                )}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={"Choose an Extension"}
                        variant="outlined"
                        className={classes.inputField}
                        inputProps={{
                            ...params.inputProps,
                            autoComplete: "new-password", // disable autocomplete and autofill
                        }}
                    />
                )}
            />
        );
    }

    return (
        <div>
            <Accordion square expanded>
                <AccordionDetails style={{ display: "inline-block" }}>
                    <div>{options}</div>
                    <div>{skills}</div>
                    <div>{agents}</div>
                </AccordionDetails>
            </Accordion>

            <div className={classes.submitbutton}>
                <div style={{ padding: "40px 0px 0px", textAlign: "center" }}>
                    <div>
                        <Button
                            autoFocus
                            className={classes.TransferCallButton}
                            onClick={handleTransfer}
                            color="primary"
                            style={{ border: "1px solid" }}
                        >
                            Transfer call
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    //console.log(state.callTransfer);
    return {
        skillError: state.callTransfer.skillError,
        skillLoading: state.callTransfer.skillLoading,
        
        error: state.callTransfer.error,
        loading: state.callTransfer.loading,
        transferableAgents: state.callTransfer.transferableAgents,
        transferableCampaign: state.callTransfer.transferableCampaign,
        transferableSkills: state.callTransfer.transferableSkills,
        transferableExtension: state.callTransfer.transferableExtension,
        agentId: state.agentData.agentId,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onGetTransferableSkill: (agentId, transferCampaignName) =>
            dispatch(
                actions.getTransferableSkill(agentId, transferCampaignName)
            ),
        onGetTransferableAgents: (agentId,transferCampaignName,transferSkill) =>
            dispatch(actions.getTransferableAgents(agentId,transferCampaignName,transferSkill)),
        onTransferAgent: (agentId, transferTo) =>
            dispatch(actions.transferAgent(agentId, transferTo)),
        onTransferCampaign: (agentId, transferCampaignName, skillFlag, skill) =>
            dispatch(
                actions.transferCampaign(
                    agentId,
                    transferCampaignName,
                    skillFlag,
                    skill
                )
            ),
        onTransferExtension: (agentId, extensionId) =>
            dispatch(actions.transferExtension(agentId, extensionId)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(TransferForm);
